import { css } from '@bts-web/utils-style-engine';
import { CellSkeleton, SkeletonElement } from '../../../../common';

export const PortfolioOverviewSkeleton = () => (
  <div
    className={css({
      display: 'flex',
      flexDirection: 'column',
      gap: 'medium',
      paddingTop: 'small',
    })}
    data-testid="portfolio-overview-skeleton"
  >
    <div className={css({ paddingLeft: 'medium' })}>
      <SkeletonElement height="24px" width="200px" />
    </div>

    <div>
      <CellSkeleton />
      <CellSkeleton />
      <CellSkeleton />
    </div>
  </div>
);
